import styled from 'styled-components'

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const Label = styled.label`
  position: relative;
  display: block;
  max-height: 9rem;
`

export const Input = styled.input`
  font-family: Navigo, Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 400;
  color: #292e3d;
  height: 5rem;
  padding: 1.5rem 2rem;
  transition: 0.2s linear 0s;
  resize: none;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 0.1rem solid #c2c7d6;
  border-radius: 0.5rem;
  outline: none;
  background-color: #fff;
  overflow: hidden;
  appearance: none;

  &:read-only,
  &:disabled {
    pointer-events: none;
    background-color: #edeff3;
    outline: none;
  }

  &:enabled:focus,
  &:enabled:active {
    border-color: #3a64f8;
    box-shadow: none;
  }

  &:hover {
    box-shadow: #c2c7d6 0 0 0 1px inset;
  }

  &:enabled:hover {
    box-shadow: #c2c7d6 0 0 0 1px inset;
  }

  &::placeholder {
    color: #282d3c;
    font-size: 1.4rem;
    line-height: 2rem;
    opacity: 0.5;
  }
`
